// Mock data for sports networking platform

export const currentUser = {
  id: 'user1',
  username: 'sarah_athletics',
  name: 'Sarah Johnson',
  email: 'sarah@example.com',
  persona: 'athlete',
  sport: 'Track & Field',
  profileImage: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400',
  coverImage: 'https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=1200',
  bio: 'Professional sprinter | Olympic hopeful | 100m & 200m specialist',
  location: 'Los Angeles, CA',
  connections: 1284,
  followers: 15600,
  following: 892,
  stats: {
    competitions: 45,
    wins: 28,
    personalBests: [
      { event: '100m', time: '10.89s', date: '2024-06-15' },
      { event: '200m', time: '22.34s', date: '2024-07-01' }
    ],
    recentPerformances: [
      { event: 'State Championship', result: '1st Place', date: '2024-07-10' },
      { event: 'National Trials', result: '3rd Place', date: '2024-06-20' }
    ]
  }
};

export const stories = [
  {
    id: 's1',
    user: {
      id: 'user2',
      name: 'Mike Chen',
      username: 'coach_mike',
      profileImage: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400',
      persona: 'coach'
    },
    images: ['https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=800'],
    timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000),
    viewed: false
  },
  {
    id: 's2',
    user: {
      id: 'user3',
      name: 'FC Barcelona',
      username: 'fc_barcelona',
      profileImage: 'https://images.unsplash.com/photo-1579952363873-27f3bade9f55?w=400',
      persona: 'club'
    },
    images: ['https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=800'],
    timestamp: new Date(Date.now() - 5 * 60 * 60 * 1000),
    viewed: false
  },
  {
    id: 's3',
    user: {
      id: 'user4',
      name: 'Dr. Emma Wilson',
      username: 'nutritionist_emma',
      profileImage: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400',
      persona: 'nutritionist'
    },
    images: ['https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=800'],
    timestamp: new Date(Date.now() - 8 * 60 * 60 * 1000),
    viewed: true
  }
];

export const posts = [
  {
    id: 'post1',
    user: {
      id: 'user5',
      name: 'Alex Rodriguez',
      username: 'alex_soccer',
      profileImage: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400',
      persona: 'athlete',
      sport: 'Soccer'
    },
    content: 'Amazing training session today! Ready for the big game this weekend 💪⚽',
    images: [
      'https://images.unsplash.com/photo-1579952363873-27f3bade9f55?w=800',
      'https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=800'
    ],
    likes: 2341,
    comments: 156,
    shares: 43,
    timestamp: new Date(Date.now() - 3 * 60 * 60 * 1000),
    liked: false,
    commentsData: [
      {
        id: 'c1',
        user: { name: 'John Doe', username: 'johndoe', profileImage: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400' },
        text: 'Great work! Keep it up!',
        timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000),
        likes: 12
      }
    ]
  },
  {
    id: 'post2',
    user: {
      id: 'user6',
      name: 'Lakers Official',
      username: 'lakers',
      profileImage: 'https://images.unsplash.com/photo-1546519638-68e109498ffc?w=400',
      persona: 'club',
      sport: 'Basketball'
    },
    content: 'Game day! Come support us at the Staples Center tonight! 🏀🔥',
    images: ['https://images.unsplash.com/photo-1546519638-68e109498ffc?w=800'],
    likes: 8932,
    comments: 423,
    shares: 234,
    timestamp: new Date(Date.now() - 5 * 60 * 60 * 1000),
    liked: true,
    commentsData: []
  },
  {
    id: 'post3',
    user: {
      id: 'user7',
      name: 'Dr. James Smith',
      username: 'physio_james',
      profileImage: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400',
      persona: 'physio',
      sport: 'Multi-sport'
    },
    content: '5 essential stretches every athlete should do before training. Save this post! 🏃‍♂️',
    images: ['https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800'],
    likes: 4521,
    comments: 289,
    shares: 1203,
    timestamp: new Date(Date.now() - 24 * 60 * 60 * 1000),
    liked: false,
    commentsData: []
  },
  {
    id: 'post4',
    user: {
      id: 'user1',
      name: 'Sarah Johnson',
      username: 'sarah_athletics',
      profileImage: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400',
      persona: 'athlete',
      sport: 'Track & Field'
    },
    content: 'New personal best! 10.89s in the 100m dash! All the hard work is paying off 🏅',
    images: ['https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=800'],
    likes: 3245,
    comments: 198,
    shares: 87,
    timestamp: new Date(Date.now() - 48 * 60 * 60 * 1000),
    liked: true,
    commentsData: []
  }
];

export const suggestedConnections = [
  {
    id: 'user8',
    name: 'Marcus Williams',
    username: 'marcus_basketball',
    profileImage: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400',
    persona: 'athlete',
    sport: 'Basketball',
    mutualConnections: 23,
    following: false
  },
  {
    id: 'user9',
    name: 'Coach Sarah Lee',
    username: 'coach_sarah',
    profileImage: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400',
    persona: 'coach',
    sport: 'Swimming',
    mutualConnections: 15,
    following: false
  },
  {
    id: 'user10',
    name: 'Elite Sports Nutrition',
    username: 'elite_nutrition',
    profileImage: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=400',
    persona: 'nutritionist',
    sport: 'Multi-sport',
    mutualConnections: 8,
    following: false
  }
];

export const messages = [
  {
    id: 'msg1',
    user: {
      id: 'user2',
      name: 'Mike Chen',
      username: 'coach_mike',
      profileImage: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400'
    },
    lastMessage: 'Great session today! See you tomorrow.',
    timestamp: new Date(Date.now() - 30 * 60 * 1000),
    unread: true
  },
  {
    id: 'msg2',
    user: {
      id: 'user5',
      name: 'Alex Rodriguez',
      username: 'alex_soccer',
      profileImage: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400'
    },
    lastMessage: 'Hey! Want to train together this weekend?',
    timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000),
    unread: true
  },
  {
    id: 'msg3',
    user: {
      id: 'user4',
      name: 'Dr. Emma Wilson',
      username: 'nutritionist_emma',
      profileImage: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400'
    },
    lastMessage: 'Here is your meal plan for next week',
    timestamp: new Date(Date.now() - 24 * 60 * 60 * 1000),
    unread: false
  }
];

export const notifications = [
  {
    id: 'notif1',
    type: 'like',
    user: {
      name: 'Marcus Williams',
      username: 'marcus_basketball',
      profileImage: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400'
    },
    text: 'liked your post',
    timestamp: new Date(Date.now() - 15 * 60 * 1000),
    read: false
  },
  {
    id: 'notif2',
    type: 'comment',
    user: {
      name: 'Alex Rodriguez',
      username: 'alex_soccer',
      profileImage: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400'
    },
    text: 'commented on your post',
    timestamp: new Date(Date.now() - 60 * 60 * 1000),
    read: false
  },
  {
    id: 'notif3',
    type: 'follow',
    user: {
      name: 'Coach Sarah Lee',
      username: 'coach_sarah',
      profileImage: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400'
    },
    text: 'started following you',
    timestamp: new Date(Date.now() - 3 * 60 * 60 * 1000),
    read: true
  }
];
